import { render, staticRenderFns } from "./PersonalAuthorizedAgreement.vue?vue&type=template&id=2d5a5f56&scoped=true"
import script from "./PersonalAuthorizedAgreement.vue?vue&type=script&lang=js"
export * from "./PersonalAuthorizedAgreement.vue?vue&type=script&lang=js"
import style0 from "./PersonalAuthorizedAgreement.vue?vue&type=style&index=0&id=2d5a5f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a5f56",
  null
  
)

export default component.exports